import {
  SYNC_USERS_LOADING,
  SYNC_USERS_SUCCESS,
  SYNC_USERS_ERROR,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAIL,
} from "./types";

import { getUsers } from "services/userService";
import { toast } from 'react-toastify';
import { postSyncUser, getSyncUsers, putSyncUser } from "services/syncUserService";
import { processErrorResponse } from 'utils/errorHandler';

export const fetchUsers = () => async (dispatch) => {
    try {
        const result = await getUsers();
        dispatch({ type: FETCH_USERS_SUCCESS, payload: result });
        return result;
    } catch (error) {
        dispatch({ type: FETCH_USERS_FAIL, payload: error.message });
        throw error;
    }
};

// export const syncUsers = () => async (dispatch) => {
//     try {
//         dispatch({ type: SYNC_USERS_LOADING });
//         await sync();
//         dispatch({ type: SYNC_USERS_SUCCESS});
//         toast.success("Users synced successfully!");
//         await dispatch(fetchUsers());
//     } catch (error) {
//         dispatch({ type: SYNC_USERS_ERROR, payload: error.message });
//         toast.error("Failed to sync users");
//         throw error;
//     }
// };

export const syncUsers = (endpoint, data) => async (dispatch) => {
    dispatch({ type: SYNC_USERS_LOADING });
    try {
        const result = await postSyncUser(endpoint, data);
        dispatch({ type: SYNC_USERS_SUCCESS, payload: result });
    } catch (error) {
        dispatch({ type: SYNC_USERS_ERROR, payload: error.message });
        processErrorResponse(error);
    }
};

export const getList = (params) => async (dispatch) => {
    try {
        dispatch({ type: "GET_USER_LOADING" });
        const query = params ? `?${new URLSearchParams(params).toString()}` : "";
        
        const data = await getSyncUsers(`/users${query}`);
        dispatch({ type: "GET_USER_SUCCESS", payload: data });
    } catch (error) {
        dispatch({ type: "GET_USER_FAILURE", payload: error.message });
        processErrorResponse(error);
    }
};

export const changeStatus = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'USER_PUT_REQUEST' });
    try {
        const result = await putSyncUser(endpoint, data);
        dispatch({ type: 'USER_PUT_SUCCESS', payload: result });

        toast.success("Users have been updated successfully!");
    } catch (error) {
        dispatch({ type: 'USER_PUT_FAILURE', error: error.message });
        processErrorResponse(error);
        throw error;
    }
};
